export default __webpack_public_path__ + "static/InterDisplay-BoldItalic-99fa823eb8cacdeb36f1f0b216303700.woff";